// import { DeleteRule, GetRuleValues } from "@/services/minimum.wage.services/rules.minimum.wages.js"

export {
    GetOptionsForProperty,
    GetValuesForGroupings
};

function GetOptionsForProperty(){
    return []
}

function GetValuesForGroupings(groupings, id){

    var groups = groupings.filter(group => {return group.id == id});
    var values = [{value: "", id: 0}];

    if(groups[0]){
        var group = groups[0];

        group.groupEntries.map(entry => {
            if(values.indexOf(entry.name) ==-1){
                values.push({value: entry.name, id: entry.id});
            }
        })
    }

    return values;
}